import React, { ReactElement } from "react";

export default function QuoteSpotHome(): ReactElement {
    return <div>Trafficbox coming soon...</div>;
}
